module.exports = __webpack_public_path__ + "img/dq_pic_data_availability.48349021.png";